import {BaseInput} from "@/components/input/BaseInput.tsx";
import {BaseSelect} from "@/components/input/BaseSelect.tsx";
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "@/store/modules";
import {useFormik} from "formik";
import {CreateInviteRequest, InviteRequestInit} from "@/model/request/invite/CreateInviteRequest.ts";
import {invite} from "@/store/modules/invite.ts";
import {StoreUtil} from "@/util/store/StoreUtil.ts";
import {notification} from "@/store/modules/notification.ts";
import {useEffect} from "react";
import {roles} from "@/store/modules/role.ts";
import {base} from "@/store/modules/base.ts";

export const InviteMember = () => {
    const RoleState = useSelector((state: RootState) => state.roles)
    const InviteState = useSelector((state: RootState) => state.invite)
    const authState = useSelector((state: RootState) => state.auth)
    const WorkSpaceState = useSelector((state: RootState) => state.workspace)
    const dispatch = useDispatch<any>()

    useEffect(() => {
        dispatch(roles.action.read())
    }, []);

    const showErrorMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "error",
                    title: "Error",
                    body: response.responseMessage,
                })
            )
        );
    };


    const showSuccessMessage = (response: any) => {
        StoreUtil.execute(() =>
            dispatch(
                notification.mutation.openModal({
                    type: "success",
                    title: "Success",
                    body: response.responseMessage,
                })
            )
        );
        dispatch(invite.action.readInvite())
        dispatch(base.mutation.resetModalOptions())
    };

    const handleSubmit = async (value: CreateInviteRequest) => {
        const request = {
            ...value,
            inviteWorkspaceId: WorkSpaceState.selectedWorkspace.workspaceId,
            inviteSenderId: authState.userInfo.userId
        };
        await dispatch(
            invite.action.createInvite({
                data: request,
                onSuccess: (response: any) => {
                    showSuccessMessage(response)
                    dispatch(base.mutation.resetModalOptions())
                },
                onError: (response: any) => showErrorMessage(response),
            })
        )
        formik.resetForm();
        console.log(request)
    };

    const formik = useFormik({
        onSubmit: handleSubmit,
        initialValues: InviteRequestInit,
    });
    return (
        <>
            <div style={{backgroundColor: "white"}}>
                <div>
                    <div className="workspace-content">
                        <form onSubmit={formik.handleSubmit}>
                            <div className="workspace-field">
                                <label>Email</label>
                                <BaseInput
                                    formik={formik}
                                    type="email"
                                    placeholder={"Enter Email"}
                                    name="inviteEmail"
                                    className="bg-white"
                                />
                            </div>
                            <div className="workspace-field">
                                <label>Member Role</label>
                                <BaseSelect
                                    formik={formik}
                                    className="form_input w-select"
                                    name="inviteRoleId"
                                    data-name="inviteRoleId"
                                    id="inviteRoleId"
                                    
                                    items={[
                                        {value: "", label: "Select Role",},
                                        ...RoleState.roles.map(item => {
                                            return {
                                                value: item.roleId,
                                                label: item.roleName,
                                            }
                                        })
                                    ]}
                                />
                            </div>
                            <div className="flex btns">
                                <a className="button is-secondary w-button"
                                   onClick={() => dispatch(base.mutation.resetModalOptions())}>Cancel</a>
                                <BaseInput
                                    type="submit"
                                    formik={formik}
                                    name={"submit"}
                                    value={"Add Member"}
                                    loading={InviteState.loading}
                                    className="button w-button"
                                />
                            </div>
                        </form>
                    </div>
                </div>
                <div className="modal1_background-overlay"></div>
            </div>
        </>
    )
}